import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './MobilePreviewPage.css';

const FRAMES = [
  { id: 'feed', label: 'Front page', src: '/feed' },
  { id: 'register', label: 'Onboarding', src: '/register' },
  { id: 'status', label: 'Status', src: '/status' },
];

const IOSFrame = ({ label, src }) => (
  <div className="mp-frame-wrap">
    <div className="mp-frame">
      <div className="mp-frame-island" aria-hidden="true" />
      <iframe
        title={`${label} preview`}
        src={src}
        className="mp-frame-iframe"
        loading="lazy"
      />
      <div className="mp-frame-home" aria-hidden="true" />
    </div>
    <div className="mp-frame-label">{label.toUpperCase()}</div>
  </div>
);

const MobilePreviewPage = () => {
  const [articleId, setArticleId] = useState('');
  const articleSrc = articleId.trim() ? `/article/${encodeURIComponent(articleId.trim())}` : null;

  return (
    <div className="mp-page">
      <header className="mp-header">
        <div>
          <h1 className="mp-title">Pocket edition</h1>
          <p className="mp-meta">iOS · 390 × 844 · Three core screens</p>
        </div>
        <Link to="/feed" className="mp-back">← Back to app</Link>
      </header>

      <p className="mp-blurb">
        Design QA for the Paperboy mobile experience. Each frame embeds the live
        responsive page at iPhone 14 Pro dimensions. Compare against the
        prototype mocks while iterating on layout, tap targets, and safe-area
        handling.
      </p>

      <div className="mp-grid">
        {FRAMES.map((f) => (
          <IOSFrame key={f.id} label={f.label} src={f.src} />
        ))}
        <div className="mp-frame-wrap">
          <div className="mp-frame">
            <div className="mp-frame-island" aria-hidden="true" />
            {articleSrc && (
              <iframe
                title="Article preview"
                src={articleSrc}
                className="mp-frame-iframe"
                loading="lazy"
              />
            )}
            <div className="mp-frame-home" aria-hidden="true" />
          </div>
          <div className="mp-story-controls">
            <label htmlFor="article-id" className="mp-empty-label">
              Story preview
            </label>
            <input
              id="article-id"
              type="text"
              className="mp-empty-input"
              value={articleId}
              onChange={(e) => setArticleId(e.target.value)}
              placeholder="Enter article id"
            />
            <span className="mp-empty-hint">
              Paste any article id to preview the story drawer in iPhone frame.
            </span>
          </div>
          <div className="mp-frame-label">STORY DETAIL</div>
        </div>
      </div>
    </div>
  );
};

export default MobilePreviewPage;
